import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/faq-category.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { FaqCategoriesService } from '../../services';

export const LoadFaqCategories$ = createEffect(
  (actions$ = inject(Actions), service = inject(FaqCategoriesService)) => {
    return actions$.pipe(
      ofType(actions.LoadFaqCategories),
      switchMap(() =>
        service.getFaqCategories().pipe(
          map(categories => actions.LoadFaqCategoriesSuccess({ categories })),
          catchError(error => of(actions.LoadFaqCategoriesFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
